<div class="bulk-csv-upload-dialog">
  <div class="dialog-header">
    <h2>Bulk Tile Creation</h2>
    <button
      type="button"
      class="close-button"
      (click)="onClose()"
    >
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>

  <div class="dialog-content">
    <div class="template-section">
      <h3><i class="fa-solid fa-circle-1"></i> Download CSV Templates</h3>
      <div class="template-section-text">
        <p>Download a template to get started with bulk tile creation. See the <a (click)="tileGlossaryNewTab()">tile term glossary</a> for what values to include in the CSV cells.</p>
      </div>

      <div class="template-buttons">
        <div class="button-with-popover">
          <button
            type="button"
            class="white indigo small"
            (click)="downloadNumericTilesTemplate()"
          >
            <i class="fa-regular fa-arrow-down-to-bracket"></i>
            <span>Numeric Tiles Template</span>
            @if (isProtocolSelectionEnabled()) {
              <i class="fa-regular fa-chevron-down dropdown-icon"></i>
            }
          </button>

          @if (numericMenuOpen && isProtocolSelectionEnabled()) {
            <moti-popover-menu
              [optionGroup]="protocolMenuGroup"
              [overlayPositions]="overlayPositions"
              (clickedOption$)="onNumericProtocolSelected($event)"
              (clickedAnywhere$)="onNumericMenuClosed()"
            ></moti-popover-menu>
          }

          @if (formulaNumericMenuOpen) {
            <moti-popover-menu
              [optionGroup]="formulaTemplateGroup"
              [overlayPositions]="overlayPositions"
              (clickedOption$)="onFormulaTemplateSelected($event)"
              (clickedAnywhere$)="onFormulaNumericMenuClosed()"
            ></moti-popover-menu>
          }
        </div>

        <div class="button-with-popover">
          <button
            type="button"
            class="white indigo small"
            (click)="downloadToggleTilesTemplate()"
          >
            <i class="fa-regular fa-arrow-down-to-bracket"></i>
            <span>Toggle Tiles Template</span>
            @if (isProtocolSelectionEnabled()) {
              <i class="fa-regular fa-chevron-down dropdown-icon"></i>
            }
          </button>

          @if (toggleMenuOpen && isProtocolSelectionEnabled()) {
            <moti-popover-menu
              [optionGroup]="toggleProtocolMenuGroup"
              [overlayPositions]="overlayPositions"
              (clickedOption$)="onToggleProtocolSelected($event)"
              (clickedAnywhere$)="onToggleMenuClosed()"
            ></moti-popover-menu>
          }
        </div>
      </div>
    </div>

    <div class="upload-section">
      <h3><i class="fa-solid fa-circle-2"></i> Upload CSV File</h3>
      <p>Upload your completed CSV file to create tiles in bulk.</p>

      <div class="file-upload-area">
        <input
          type="file"
          #fileInput
          accept=".csv"
          (change)="onFileSelected($event)"
          style="display: none"
        >

        <div
          class="upload-dropzone"
          (click)="fileInput.click()"
          [ngClass]="{'has-file': selectedFile}"
        >
          @if (!selectedFile) {
            <motn-fa-icon icon="fa-regular fa-cloud-arrow-up"></motn-fa-icon>
            <p>Select your CSV file</p>
            <span class="file-hint">Max 5MB</span>
          } @else {
            <motn-fa-icon icon="fa-regular fa-file-lines"></motn-fa-icon>
            <p>{{ selectedFile.name }}</p>
            <span class="file-size">{{ formatFileSize(selectedFile.size) }}</span>
          }
        </div>
      </div>
    </div>
  </div>

  <div class="dialog-footer">
    <div class="buttons">
      <button
        type="button"
        class="alt"
        (click)="onClose()"
      >
        Cancel
      </button>

      <button
        type="button"
        class="green"
        [disabled]="!selectedFile || processingUpload"
        [class.loading]="processingUpload"
        (click)="processCSVUpload()"
      >
        <span>{{ validatingFormulas ? 'Validating...' : 'Create Tiles' }}</span>
        <motn-spinner></motn-spinner>
      </button>
    </div>
  </div>
</div>
